import InviraUserList from './InviraUserList.vue'
export {InviraUserList}
export default InviraUserList

